import locationHash from './locationHash'

const isRSVP = (locationHash.patientId || locationHash.patientPmsId) && locationHash.chairfillId
const isMounted = locationHash.mounted

export default { isRSVP, isMounted }
